import { computed, signal } from "@preact/signals";
import * as languages from "~/lang";

const makeI18n = () => {
    const code = signal<keyof typeof languages>("en");
    const lang = computed(() => languages[code.value]);

    return { code, lang };
};

export default makeI18n;
